import React from 'react';
import { PATH_APP } from 'src/routes/paths';
import { MIcon } from '../../../theme';
import { FaUsers } from "react-icons/fa";
import { GrConfigure } from "react-icons/gr";
import { RiFileEditLine } from "react-icons/ri";
import { FaFile } from "react-icons/fa";
import { RiSignalTowerFill } from "react-icons/ri";
import { FiClock } from "react-icons/fi";
// import { FiSettings } from "react-icons/fi"; // alternativa si necesitas otro icono


const path = name => `/static/icons/navbar/${name}.svg`;

const ICONS = {
  dashboard: <MIcon src={path('ic_edit_file')} />,
  users: <MIcon src={path('ic_user')} />,
  user: <MIcon src={path('ic_user')} />,
  upload: <MIcon src={path('ic_upload')} />,
  bulkUpload: <MIcon src={path('ic_upload')} />,
  page: <MIcon src={path('file-document-multiple')} />,
  editor: <MIcon src={path('ic_editor')} />,
  charts: <MIcon src={path('ic_charts')} />,
  signers: <FaUsers style={{fontSize: "24px"}} />,
  profiles: <MIcon src={path('file-document-multiple')} />
};

const navConfig = [
  {
    subheader: 'general',
    items: [
      {
        title: 'Crear Procesos',
        icon: ICONS.dashboard,
        href: PATH_APP.general.root,
        permission: true,
      },
      {
        title: 'Procesos',
        icon: ICONS.page,
        href: PATH_APP.app.documents,
      },
      {
        title: 'Mis firmas pendientes',
        icon: <FiClock style={{fontSize: "18px"}} />,
        href: PATH_APP.app.misFirmasPendientes,
      },
      {
        title: 'Carga Masiva',
        icon: ICONS.bulkUpload,
        href: PATH_APP.app.bulkUpload,
        permission: true,
      },
      {
        title: 'Firmantes',
        icon: ICONS.signers,
        href: PATH_APP.app.signers,
        // admin: true,
        permission: true,
      },
      {
        title: 'Usuarios',
        icon: ICONS.users,
        href: PATH_APP.app.users,
        admin: true,
      },
      {
        title: 'Configuración',
        icon: <GrConfigure style={{fontSize: "18px"}}/>,
        href: PATH_APP.app.config,
        admin: true,
      },
      {
        title: 'Perfiles de Proceso',
        icon: ICONS.profiles,
        href: PATH_APP.app.processProfiles,
        permission: true,
      },
      {
        title: 'Documento Base',
        icon: <RiFileEditLine style={{fontSize: "18px"}}/>,
        href: PATH_APP.app.templates,
        admin: true,
      },
      {
        title: 'Adjuntos',
        icon: <FaFile style={{fontSize: "18px"}}/>,
        href: PATH_APP.app.adjuntos,
        admin: true,
      },
      {
        title: 'Estado de Servicios',
        icon: <RiSignalTowerFill style={{fontSize: "18px"}}/>,
        href: PATH_APP.app.api_status,
        admin: true,
      },
      {
        title: 'Panel QA',
        icon: <MIcon src={path('ic_charts')} />,
        href: PATH_APP.app.qaPanel,
        admin: true,
        // Solo visible para estos correos (lista blanca, en minúsculas).
        emails: ['polysign@polysistemas.com.pe', 'henryvc@dojofullstack.com', 'hola@dojofullstack.com'],
      },
    ],
  },
];

export default navConfig;
